export default {
	sec_10: {
		title: {
			one: '송금 수수료 ',
			two: '무료',
		},
		desc: {
			one: 'JP WORLD PAY간의 송금시 수수료 무료!',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_11: {
		one: {
			title: {
				one: '외부 지갑 입금시',
				two: '네트워크비용만',
			},
			desc: {
				one: '입금시 JP WORLD PAY에서는 수수료 지불요청을 하지 않습니다.',
			},
		},
		two: {
			title: {
				one: '자사의플랫폼 내의 이동은 무료입니다.',
			},
			desc: {
				one: '외부 출금시에만 수수료 발생 JP WORLD PAY를 이용하여 구입시 수수료 무료',
			},
		},
	},
};
